module.exports = __webpack_public_path__ + "static/media/Operating Systems.e07444a5.jpg";